/* Project Import will be here */
import { post, IRequest, authTokenKey } from "./index";
/* Project Import will be here */

/* Get the application settings configurations */
export const getAppSettingConfig = (token) => {
    let request: IRequest = null;

    if (token !== null)
        request = { subUrl: `/appconfig/pwaconfig`, headers: { [authTokenKey]: token } };
    else
        request = { subUrl: `/appconfig/pwaconfig` };
    
    return post(request);
};